import {
  RecipientValidationFailureReason,
  RecipientValidationMultiRequest,
  RecipientValidationMultiResponse,
} from '@interfaces';
import { createAction, props } from '@ngrx/store';

export const validateRecipientAccount = createAction(
  '[RecipientValidation] Validate Account',
  props<{ accountNumber: string; ownerName: string }>(),
);
export const incrementAttemptCount = createAction('[RecipientValidation] Increment Attempt Count');

export const setRecipientValidation = createAction(
  '[RecipientValidation] Set Account Validation',
  props<{
    accountNumber: string;
    valid: boolean;
    failureReasons?: RecipientValidationFailureReason[];
  }>(),
);

export const validateMultiITAccounts = createAction(
  '[RecipientValidation] Validate Multi IT Accounts',
  props<{ accounts: RecipientValidationMultiRequest }>(),
);

export const setMultiITValidationResults = createAction(
  '[RecipientValidation] Set Multi IT Validation Results',
  props<{ results: RecipientValidationMultiResponse }>(),
);

export const clearMultiITValidationResults = createAction(
  '[RecipientValidation] Clear Multi IT Validation Results',
);
